const accessNothingComponent = {
    templateUrl: '/modules/access-nothing/access-nothing.html',
    controller: 'AccessNothingController',
};

export default angular
    .module('access-nothing.module', [
        'ui.router',
    ])
    .component('accessNothingComponent', accessNothingComponent)
    .config(function($stateProvider) {
        $stateProvider.state('access-nothing', {
            url: '/no-access',
            component: 'accessNothingComponent',
        });
    });
